import { Bold, Icons } from '@serodigital/ui-components';
import * as React from 'react';

interface IBackButtonProps {
  onClick: () => void;
}

export function BackButton({ onClick }: IBackButtonProps) {
  return (
    // rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      data-qa={'back-button'}
      onClick={onClick}
      className="flex items-center cursor-pointer text-grey-secondary-text fill-grey-secondary-text pb-16 space-x-8"
    >
      <Icons.ChevronLeft width={20} height={20} />
      <Bold size="small">Back</Bold>
    </div>
  );
}
